import { Form, InputNumber, message, Row, Select, Typography } from "antd";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import FieldFilter from "components/field-filter";
import { getFoodieCategories, getInfluencers } from "services/SauceService";
import CheckboxGroup from "components/checkbox-group/CheckboxGroup";
import LocationField from "components/location-field/LocationField";
// import InfluencerModal from "components/influencer-modal";
import { useSelector } from "react-redux";
import { SubscriptionType } from "enums/SubscriptionType";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faUsers,
  faTags,
  faTriangleExclamation,
  faLocationDot,
  faVenusMars,
} from "@fortawesome/free-solid-svg-icons";
import { BusinessState } from "redux-context/business";
import "./Influencers.scss";
import CreatorCard from "./CreatorCard";
import InfluencerCard from "./InfluencerCard";
import Loader from "components/loader/Loader";

const genderOptions = [
  // { value: "all", label: "All Genders" },
  { value: "male", label: "Male" },
  { value: "female", label: "Female" },
  { value: "nonBinary", label: "Non binary" },
];

const dietaryRestrictions = [
  { value: "vegetarian", label: "Vegetarian" },
  { value: "vegan", label: "Vegan" },
  { value: "lactoseIntolerance", label: "Lactose Intolerance" },
  { value: "glutenIntolerance", label: "Gluten Intolerance" },
  { value: "noPork", label: "No Pork" },
  { value: "nutsAllergy", label: "Nuts Allergies" },
  { value: "pescatarian", label: "Pescatarian" },
  { value: "shellfishAllergy", label: "Shellfish Allergy" },
];

const Influencers: React.FC = () => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [filter, setFilter] = useState({
    skip: 0,
    limit: 24,
  });
  const [categories, setCategories] = useState<any[]>([]);
  const [localLoading, setLocalLoadingLoading] = useState(false);
  const [influencers, setInfluencers] = useState<any>({ data: [], total: 0 });
  const [totalInfluencers, setTotalInfluencers] = useState<number>(0);
  // const [selectedFoodie, setSelectedFoodie] = useState<string>("");
  // const [openFoodieModal, setOpenFoodieModal] = useState<boolean>(false);
  const { subscription } = useSelector(
    (state: BusinessState) => state.business
  );
  const freemium = subscription?.subscriptionType === SubscriptionType.Fremium;

  const tabOptions = [{ value: "Pending", label: `Applications` }];
  if (!freemium)
    tabOptions.push({ value: "All influencers", label: "All Influencers" });

  const onClickFoodie = (foodieId: string) => {
    // setSelectedFoodie(foodieId);
    // setOpenFoodieModal(true);
    navigate(`/creators/${foodieId}`);
  };

  const getAllInfluencers = useCallback(async () => {
    try {
      setLocalLoadingLoading(true);
      const response: any = await getInfluencers(filter);
      setInfluencers((prev: any) => ({
        ...prev,
        ...response,
        data: [...prev.data, ...response.data],
      }));

      setTotalInfluencers(response.total);
      setLocalLoadingLoading(false);
    } catch (error) {
      setInfluencers({ data: [], total: 0 });
      setLocalLoadingLoading(false);
      message.error("Error fetching influencers");
    }
  }, [filter]);

  const onFinish = (values: any) => {
    setInfluencers({ data: [], total: 0 });
    setFilter({ ...filter, ...values, skip: 0 });
  };

  useEffect(() => {
    const fetchCategories = async () => {
      const response: any = await getFoodieCategories();
      setCategories(
        response.map((item: any) => ({ value: item, label: item }))
      );
    };
    fetchCategories();
  }, []);

  useEffect(() => {
    getAllInfluencers();
  }, [getAllInfluencers]);

  useEffect(() => {
    const handleScroll = () => {
      const nearBottom =
        Math.abs(
          window.innerHeight +
            document.documentElement.scrollTop -
            document.documentElement.offsetHeight
        ) < 10;
      if (nearBottom && !localLoading) {
        setFilter((prevFilter) => ({
          ...prevFilter,
          skip: prevFilter.skip + prevFilter.limit,
        }));
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [localLoading, filter]);

  return (
    <div className="influencers">
      <Loader visible={localLoading} />
      <Row justify="space-between">
        <Form
          form={form}
          onFinish={onFinish}
          layout="vertical"
          // initialValues={{ gender: "all" }}
        >
          <div
            style={{
              display: "flex",
              gap: 8,
              marginBottom: 40,
              alignItems: "center",
            }}
          >
            <FieldFilter
              name="minAmountFollowers"
              label="Min"
              icon={<FontAwesomeIcon icon={faUsers} />}
              valueFunction={(value: any) => {
                const n = typeof value === "number" ? value : Number(value);
                if (!n || isNaN(n)) return "Min";
                if (Math.abs(n) >= 1_000_000)
                  return `Min: ${Math.round(n / 1_000_0) / 100}M`;
                if (Math.abs(n) >= 1_000)
                  return `Min: ${Math.round(n / 100) / 10}K`;
                return `Min: ${n}`;
              }}
            >
              <InputNumber placeholder="Enter a number" />
            </FieldFilter>

            <FieldFilter
              name="categories"
              label="Categories"
              icon={<FontAwesomeIcon icon={faTags} />}
              search
              formLabel="Categories"
            >
              <CheckboxGroup
                options={categories}
                allValue="all"
                allLabel="All Categories"
              />
            </FieldFilter>
            <FieldFilter
              name="dietaryRestrictions"
              label="Allergies"
              icon={<FontAwesomeIcon icon={faTriangleExclamation} />}
              search
              formLabel="Allergies"
            >
              <CheckboxGroup
                options={dietaryRestrictions}
                allValue="none"
                allLabel="No preference"
              />
            </FieldFilter>
            <FieldFilter
              name="location"
              label="Location"
              icon={<FontAwesomeIcon icon={faLocationDot} />}
              // valueFunction={(value: any) => value?.name}
              // showButtons={false}
            >
              <LocationField />
            </FieldFilter>
            <FieldFilter
              name="gender"
              label="Gender"
              icon={<FontAwesomeIcon icon={faVenusMars} />}
              // valueFunction={(value: any) => {
              //   const found = genderOptions.find((o) => o.value === value);
              //   const text = found
              //     ? found.label.replace("All Genders", "All")
              //     : value;
              //   return `Gender: ${text}`;
              // }}
              // showButtons={false}
            >
              <Select style={{ width: "100%" }} options={genderOptions} />
            </FieldFilter>
          </div>
        </Form>
      </Row>

      <Row style={{ marginBottom: 40 }}>
        <Typography.Text>{totalInfluencers} creators found</Typography.Text>
        {(() => {
          const values = form.getFieldsValue();
          const applied = Object.entries(values).filter(([_, v]) => {
            if (v === undefined || v === null) return false;
            if (v === "all" || v === "none") return false;
            if (Array.isArray(v) && v.length === 0) return false;
            if (typeof v === "string" && v.trim() === "") return false;
            return true;
          });

          if (applied.length === 0) return null;

          // Build label maps for pretty rendering
          const keyLabels: Record<string, string> = {
            minAmountFollowers: "Min followers",
            gender: "Gender",
            dietaryRestrictions: "Dietary restrictions",
            categories: "Categories",
            location: "Location",
          };

          const genderLabelMap = Object.fromEntries(
            genderOptions.map((o: any) => [o.value, o.label])
          ) as Record<string, string>;

          const dietaryLabelMap = Object.fromEntries(
            dietaryRestrictions.map((o: any) => [o.value, o.label])
          ) as Record<string, string>;

          const categoryLabelMap = Object.fromEntries(
            (categories || []).map((o: any) => [o.value, o.label])
          ) as Record<string, string>;

          const numberFmt = new Intl.NumberFormat();

          const formatValue = (key: string, value: any) => {
            switch (key) {
              case "minAmountFollowers":
                if (typeof value === "number") {
                  return `${numberFmt.format(value)}+ followers`;
                }
                return String(value);
              case "gender":
                return genderLabelMap[value] ?? String(value);
              case "dietaryRestrictions":
                return Array.isArray(value)
                  ? value.map((v: string) => dietaryLabelMap[v] ?? v).join(", ")
                  : dietaryLabelMap[value] ?? String(value);
              case "categories":
                return Array.isArray(value)
                  ? value
                      .map((v: string) => categoryLabelMap[v] ?? v)
                      .join(", ")
                  : categoryLabelMap[value] ?? String(value);
              case "location":
                if (typeof value === "string") {
                  return value === "all" ? "All Locations" : value;
                }
                if (value?.name)
                  return `${value.name}, ${value.maxMilesDistance} miles distance`;
                return "Location selected";
              default:
                return Array.isArray(value) ? value.join(", ") : String(value);
            }
          };

          return (
            <>
              <ul style={{ margin: 0 }}>
                {applied.map(([key, value]) => (
                  <li key={key}>
                    <strong>{keyLabels[key] ?? key}:</strong>{" "}
                    {formatValue(key, value)}
                  </li>
                ))}
              </ul>
            </>
          );
        })()}
      </Row>
      <Row gutter={[16, 16]} style={{ gap: 16 }}>
        {influencers.data?.map((influencer: any, idx: number) => (
          <CreatorCard
            creator={influencer}
            onInfluencerClick={() => onClickFoodie(influencer.foodieId)}
            key={`INFLUENCER_${influencer.foodieId}_${influencer.collabId}_${idx}`}
            index={idx}
          />
          // <InfluencerCard
          //   influencer={influencer}
          //   onInfluencerClick={() => onClickFoodie(influencer.foodieId)}
          //   key={`INFLUENCER_${influencer.foodieId}_${influencer.collabId}_${idx}`}
          // />
        ))}
      </Row>
    </div>
  );
};

export default Influencers;
